module.exports = __webpack_public_path__ + "static/img/p-3.b289bbe.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/p-3.png
// module id = bI4O
// module chunks = 0